(function ($) {
	function update_giftaid_values() {
		var $donation_amount = $(
			"input[type='radio'][name='donation_amount']:checked"
		).val();
		if ($donation_amount === 'custom') {
			var $donation_amount = $(
				"input[type='number'][name='custom_amount_value']"
			).val();
			var $donation_amount = $donation_amount !== '' ? $donation_amount : 0;
		}
		var $value = Number.parseFloat($donation_amount).toFixed(2);
		$('#donation_total').html('£' + $value);
		var $updated_value = Number.parseFloat($value * 1.25).toFixed(2);
		$('#giftaid_total').html('£' + $updated_value);
	}
	$(document).ready(function () {
		update_giftaid_values();
		$('.update_giftaid').change(function () {
			update_giftaid_values();
		});
	});
})(jQuery);
